import { motion } from 'framer-motion';
import { Phone, Mail } from 'lucide-react';

const Navigation = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.nav
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 px-6 py-6"
    >
      <div className="max-w-7xl mx-auto">
        <div className="bg-white/10 backdrop-blur-md border border-white/20 shadow-lg rounded-full px-8 py-4 flex items-center justify-between">
          <h1 className="font-heading text-xl md:text-2xl text-primary">
            Cabanas Meio do Mato
          </h1>
          
          <div className="hidden md:flex items-center gap-8">
            <button 
              data-testid="nav-accommodations-btn"
              onClick={() => scrollToSection('accommodations')} 
              className="text-sm text-primary hover:text-accent transition-colors"
            >
              Acomodações
            </button>
            <button 
              data-testid="nav-booking-btn"
              onClick={() => scrollToSection('booking')} 
              className="text-sm text-primary hover:text-accent transition-colors"
            >
              Reservas
            </button>
            <button 
              data-testid="nav-faq-btn"
              onClick={() => scrollToSection('faq')} 
              className="text-sm text-primary hover:text-accent transition-colors"
            >
              FAQ
            </button>
            <a 
              data-testid="nav-whatsapp-link"
              href="https://wa.me/5521996273547" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm bg-primary text-white hover:bg-primary/90 rounded-full px-6 py-2 transition-all hover:scale-105"
            >
              <Phone size={16} />
              WhatsApp
            </a>
          </div>
          
          <a 
            data-testid="nav-whatsapp-mobile-link"
            href="https://wa.me/5521996273547" 
            target="_blank" 
            rel="noopener noreferrer"
            className="md:hidden flex items-center gap-2 text-sm bg-primary text-white hover:bg-primary/90 rounded-full px-4 py-2"
          >
            <Phone size={16} />
          </a>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navigation;